import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { ViewWorkspaceInviteLink } from './invite_link/ViewWorkspaceInviteLink';
import { ViewAvailableSeats } from './seats/ViewAvailableSeats';
import { WInputUserInvitationEmail } from './table_invitations/WInputUserInvitationEmail';
import { WTableUserInvitations } from './table_invitations/WTableUserInvitations';
import { WTableUsers } from './table_users/WTableUsers';

export const TabSettingsWorkspaceUserInvitationsShared = () => {
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * HTML
   */

  if (workspace_current.is_personal) return <></>;

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.USERS} required_owner_access>
      <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
        <ViewAvailableSeats />

        <ViewWorkspaceInviteLink />

        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.users.shared.invite_by_email_component.title)}</span>
        <WInputUserInvitationEmail />

        <WTableUserInvitations />

        <WTableUsers />
      </div>
    </TabSettingsWorkspaceWrapper>
  );
};
